export const EXIT_POPUP_ID = 'exitPopup';

export const COMMON_POPUP_ID = 'commonPopup';

export const FATAL_ERROR_POPUP_ID = 'fatalErrorPopup';

export const AGE_GATE_POPUP_ID = 'contentRatingAdvisoryPopup';

export const GEO_BLOCK_POPUP_ID = 'geoBlockedPopup';

export const CSL_BLOCK_POPUP_ID = 'CSLBlockedPopup';

export const PROFILES_GATE_POPUP_ID = 'profilesGatePopup';

export const KIDS_LEAVE_POPUP_ID = 'kidsLeavePopup';

export const BROADCASTING_LOCK_POPUP_ID = 'liveBroadcastingLockPopup';

export const FREEMIUM_LOCK_POPUP_ID = 'freemiumLockPopup';

export const PARENTAL_CODE_POPUP_ID = 'parentalCodePopup';

export const EPG_POPUP_ID = 'epgPopup';

export const EPG_LAYOUT_POPUP_ID = 'epgLayoutPopup';

export const GRID_POPUP_ID = 'gridPopup';

export const SUBSCRIPTION_POPUP_ID = 'subscriptionPopup';

export const ACCOUNT_COMPLETION_POPUP_ID = 'accountCompletionPopup';

export const CONTENT_RATING_POPUP_ID = 'contentRating';

export const PARENTAL_FILTER_POPUP_ID = 'parentalFilter';

export const MAX_PARENTAL_CODE_POPUP_ID = 'maxParentalCodePopup';
